import React from "react";
import List from "@mui/material/List";
import {useSelector} from "react-redux";
import {useDebouncedCallback} from "use-debounce";
import MeterListDataManager from "./MeterListDataManager";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import {store} from "../../../redux/store";
import { sortByChanged, sortDirectionChanged } from "./meterListSlice";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Radio from "@mui/material/Radio";
import SortBy from "../../../components/list/sort/SortBy";
import SortDirection from "../../../components/list/sort/SortDirection";

export default function MeterListSortConfig () {
    const requestParams = useSelector((state) => state.meterList.requestParams)
    const loadData = useDebouncedCallback(() => {
        MeterListDataManager.load()
    }, 1000)

    if (!requestParams) {
        return <></>
    }

    return (
        <>
            <List>
                <SortBy>
                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('name'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'name'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-name'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-name" primary="Nazwy"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortByChanged('last-measurement-time'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortBy === 'last-measurement-time'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'last-measurement-time'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="last-measurement-time" primary="Czasu ostatniego pomiaru"/>
                        </ListItemButton>
                    </ListItem>
                </SortBy>

                <SortDirection>
                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortDirectionChanged('asc'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortDirection === 'asc'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-asc'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-asc" primary="Rosnąco"/>
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => {
                            store.dispatch(sortDirectionChanged('desc'))
                            loadData()
                        }}>
                            <ListItemIcon>
                                <Radio
                                    edge="start"
                                    checked={requestParams.sortDirection === 'desc'}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': 'sort-by-desc'
                                    }}/>
                            </ListItemIcon>

                            <ListItemText id="sort-by-desc" primary="Malejąco"/>
                        </ListItemButton>
                    </ListItem>
                </SortDirection>
            </List>
        </>
    )
}